import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faCircle as faCircleFull } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, useTheme } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { MprcText } from "components";
import { DevPlanItemCardDto, DevPlanStateIndicator } from "generated/CoreApi_v1";
import React from "react";
import { CardDtoToDevPlanItemCardRibbon } from 'views/lms/devPlan/Home/Edit/EditDevPlanView/CardDtoToDevPlanItemCardRibbon';

interface IProps {
    item: DevPlanItemCardDto;
    readonly: boolean;
    onReload: () => void;
}

export const DevPlanCardItem: React.FC<IProps> = (props) => {

    const { item, readonly, onReload } = props;

    const theme = useTheme();

    return (
        <Grid
            container
            spacing={2}
            alignItems="flex-start"
            justifyContent="flex-start"
            wrap="nowrap"
            width={"100%"}
            className={item.card.disabled ? AppGlobalClassKeys.filterDisabled : undefined}
        >
            <Grid>
                <MprcText
                    color={
                        item.stateIndicator == DevPlanStateIndicator.Error
                            ? "error"
                            : item.stateIndicator == DevPlanStateIndicator.Checked
                                ? "success"
                                : item.stateIndicator == DevPlanStateIndicator.Highlight
                                    ? "primary"
                                    : "muted"
                    }
                >
                    <FontAwesomeIcon
                        icon={
                            item.stateIndicator == DevPlanStateIndicator.Highlight ? faCircleFull :
                                item.stateIndicator == DevPlanStateIndicator.Error ? faCircleExclamation
                                    : item.stateIndicator == DevPlanStateIndicator.Checked ? faCircleCheck
                                        : faCircle
                        }
                        fontSize={22}
                        fixedWidth
                        color={
                            item.stateIndicator == DevPlanStateIndicator.Highlight ? theme.palette.primary.main :
                                item.stateIndicator == DevPlanStateIndicator.Error ? theme.palette.error.main
                                    : item.stateIndicator == DevPlanStateIndicator.Checked ? theme.palette.success.main
                                        : theme.palette.muted.main
                        }

                    />
                </MprcText>
            </Grid>
            <Grid size="grow">
                {CardDtoToDevPlanItemCardRibbon([item.card], readonly, { onCarouselReload: onReload })}
            </Grid>
        </Grid>
    );
};
